module.exports = __webpack_public_path__ + "img/logo-azul.fc177a10.svg";